import React from 'react';
import {
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  BarChart,
} from 'recharts';
import { formatCurrency } from '../../../../../../utils/CurrencyUtils';
import { useScreenView } from '../../../../../../utils/ScreenViewContext';
import { ReferralPayoutObject } from '../../../../../../types/apiTypes';
import { ClipLoader } from 'react-spinners';

function ReferralPayoutSummary({
  addClass,
  payoutObjects,
  loadingPayoutSummary,
}: {
  addClass?: string;
  payoutObjects: ReferralPayoutObject[];
  loadingPayoutSummary: boolean;
}) {
  const { screenView } = useScreenView();
  const renderScreenView = (screenView: string) => {
    switch (screenView) {
      case 'desktop':
      case 'tablet':
      case 'mobile':
        return (
          <>
            {!loadingPayoutSummary ? (
              <div
                className={`relative flex h-[438px] max-h-[438px] flex-col items-center gap-x-[16px] border-[1px] border-bordergray bg-white align-middle ${addClass} w-full`}
              >
                <div className="flex h-[56px] max-h-[56px] w-full flex-row items-center justify-between border-b-[1px] border-bordergray p-4 align-middle">
                  <h2 className="text-[16px] font-semibold leading-[24px] text-primary">
                    Referral Payout Summary
                  </h2>
                </div>
                <div className="flex h-[84px] max-h-[84px] w-full flex-row items-start overflow-x-auto overflow-y-hidden border-b-[1px] border-[#EAECF0] align-middle">
                  <div className="flex w-[50%] flex-col items-start gap-y-2 p-3 align-middle">
                    <p className="text-[16px] text-[#7D8191]">
                      {' '}
                      Total Earnings{' '}
                    </p>
                    <p className="text-[22px] font-semibold leading-[28px] text-primary">
                      {formatCurrency(
                        payoutObjects?.reduce(
                          (acc, curr) => acc + curr.revenue,
                          0
                        )
                      )}
                    </p>
                  </div>
                </div>
                <div className="flex h-[298px] max-h-[298px] min-h-[298px] w-full flex-col items-center justify-center py-2">
                  <ResponsiveContainer width="100%" height="80%">
                    <BarChart
                      data={payoutObjects}
                      layout="horizontal"
                      margin={{ left: -15, right: 15 }}
                    >
                      {/* Y Axis represents categories */}
                      <YAxis type="number" />

                      {/* X Axis represents the value range */}
                      <XAxis
                        type="category"
                        dataKey="month"
                        tickFormatter={(value) => {
                          const date = new Date(value + '-01'); // Add day to make valid date
                          return date.toLocaleString('en-US', {
                            month: 'short',
                          });
                        }}
                      />
                      <XAxis dataKey="payout" xAxisId={0} hide />
                      {/* Tooltip */}
                      <Tooltip />

                      <Bar
                        dataKey="revenue"
                        fill="#013366"
                        barSize={30}
                        opacity={100}
                        style={{ zIndex: 1 }}
                        radius={[4, 4, 0, 0]}
                        xAxisId={0}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
            ) : (
              <div className="flex h-[438px] max-h-[438px] w-full items-center justify-center border-[1px] border-bordergray bg-white">
                <ClipLoader
                  color="#1D213B"
                  loading={loadingPayoutSummary}
                  size={40}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                  className="flex h-full w-full justify-center"
                />
              </div>
            )}
          </>
        );
    }
  };

  return <>{renderScreenView(screenView)}</>;
}

export default ReferralPayoutSummary;
